import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Steps } from 'intro.js-react'
import styles from './styles.module.scss'
import 'intro.js/introjs.css'
import { useSelector } from 'react-redux'

function TutorialV2({ closeModal, onboardingType }) {
  const { t } = useTranslation()
  const [stepsEnabled, setStepsEnabled] = useState(true)
  const [initialStep, setInitialStep] = useState(0)
  const [steps, setSteps] = useState([])

  const { sidebar } = useSelector((state) => {
    if (state.organization?.header) {
      return state.organization.header
    }
    return {}
  })
  const {
    common: { isMobile, isNative },
    myhome: { all }
  } = useSelector((state) => state)

  useEffect(() => {
    setTimeout(() => {
      if (onboardingType === 'first_time') {
        const isDashboardExist = sidebar?.dashboard?.group_id > 0 || sidebar?.dashboard?.workplace_id > 0
        const createGroupCard = document.querySelector('#onboarding_createGroup')
        if (sidebar && all.group_list?.length > 0) {
          setSteps(
            [
              {
                element: '#onboarding_myhome',
                intro: getCard(t('sidebar.home'), t('onboarding.myHome'), 'myhome.png'),
                position: 'right',
                tooltipClass: 'normalTooltip'
              },
              {
                element: '#onboarding_feed',
                intro: getCard(t('sidebar.feed'), t('onboarding.feed'), 'myfeed.png'),
                position: 'right',
                tooltipClass: 'normalTooltip'
              },
              {
                element: '#onboarding_discover',
                intro: getCard(t('sidebar.discover'), t('onboarding.discover'), 'discover.png'),
                position: 'right',
                tooltipClass: 'normalTooltip'
              },
              {
                ...(isDashboardExist && !isMobile
                  ? {
                      element: '#onboarding_dashboard',
                      intro: getCard(t('sidebar.dashboards'), t('onboarding.dashboard'), 'dashboard.png'),
                      position: 'right',
                      tooltipClass: 'normalTooltip'
                    }
                  : null)
              },
              {
                element: '#onboarding_calendar',
                intro: getCard(t('sidebar.calendar'), t('onboarding.calendar'), 'calendar.png'),
                position: 'right',
                tooltipClass: 'normalTooltip'
              },
              {
                // element with mobile id(onboarding_general_group_mobile) does not exist on html page, so for mobile, it will not do scrolling and just show tooltip. Same for #onboarding_firstSuggestedGroup_mobile
                element: isMobile || isNative ? '#onboarding_general_group_mobile' : '#onboarding_general_group',
                intro: getCard(t('myhome.mygroups.generalGroup'), t('onboarding.generalGroup'), 'general-group.png'),
                position: 'right',
                tooltipClass: 'wideTooltip normalTooltip'
              },
              {
                ...(createGroupCard === null
                  ? {
                      element:
                        isMobile || isNative
                          ? '#onboarding_firstSuggestedGroup_mobile'
                          : '#onboarding_firstSuggestedGroup',
                      intro: getCard(t('onboarding.joinGroupTitle'), t('onboarding.joinGroupInfo'), 'join-group.png'),
                      position: 'right',
                      tooltipClass: `wideTooltip normalTooltip`
                    }
                  : null)
              }
            ].filter((x) => {
              return x.element
            })
          )
        }
      }
    }, 1000)
  }, [sidebar, all.group_list])

  useEffect(() => {
    if (onboardingType === 'second_time' && localStorage.getItem('showSecondOnboarding')) {
      setSteps([
        {
          element: '#notification_icon_button',
          intro: getCard(t('onboarding.notificationTitle'), t('onboarding.notificationInfo'), 'notification.png'),
          position: 'right',
          tooltipClass: 'normalTooltip'
        },
        {
          element: '#onboarding_messenger',
          intro: getCard(t('onboarding.messengerTitle'), t('onboarding.messengerInfo'), 'messenger.png'),
          position: 'right',
          tooltipClass: 'normalTooltip'
        }
      ])
    }
  }, [onboardingType])

  const getCard = (title, subTitle, img) => {
    return `<div class=${styles.onboardingCard}><img src='${config.assetUrl}/images/tutorialV2/${img}' /><div class=${styles.text}><p class=${styles.title}>${title}</p><p class=${styles.subtitle}>${subTitle}</p></div></div>`
  }

  const handleExit = () => {
    setStepsEnabled(false)
    if (onboardingType === 'first_time') {
      localStorage.setItem('showSecondOnboarding', true)
    } else if (onboardingType === 'second_time') {
      localStorage.removeItem('showSecondOnboarding')
    }
    if (closeModal) {
      closeModal()
    }
  }
  return (
    steps?.length > 0 && (
      <Steps
        options={{ doneLabel: t('global.done'), scrollToElement: true, tooltipClass: 'normalTooltip' }}
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={handleExit}
      />
    )
  )
}

export default TutorialV2
